// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import axios from 'axios'
import VueScrollactive from 'vue-scrollactive'
import App from './ClientApp'
import store from './store'
import router from './router/client.index'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import UUID from 'vue-uuid'
import IdleVue from 'idle-vue-2'
import moment from 'moment'
import Tracker from '@openreplay/tracker'
import trackerAssist from '@openreplay/tracker-assist'
import VueSignaturePad from 'vue-signature-pad'
import { ConsoleLog } from '@openreplay/tracker/lib/common/messages'
import api from '@/api'

Vue.config.productionTip = false

axios.defaults.baseURL = process.env.VUE_APP_APILOCATION
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN"
axios.defaults.xsrfCookieName = "csrftoken"
axios.defaults.withCredentials = true

let urlParams = new URLSearchParams(window.location.search);

if (urlParams.has('appLogin')) {
  store.commit('auth/setAppVersion', urlParams.get('appLogin'))
}

if (urlParams.has('clean')) {
  localStorage.clear()
  store.commit('auth/setCheckedSession')
} else {
  const appToken = urlParams.get('appToken')
  const token = localStorage.getItem('user-token')
  const expire = localStorage.getItem('user-token-expiry')
  const user = localStorage.getItem('user-name')
  const name = localStorage.getItem('user-full-name')

  const cleanAppTokenUrl = () => {
    if (urlParams.has('appToken')) {
      urlParams.delete('appToken')
      const newQuery = urlParams.toString()
      const newUrl = window.location.pathname + (newQuery ? `?${newQuery}` : '') + window.location.hash
      window.history.replaceState(null, '', newUrl)
    }
  }

  const handleSuccess = (data) => {
    return store.dispatch('auth/setCookieSession', {
      user: data.email,
      name: `${data.first_name} ${data.last_name}`,
      id: data.id
    })
  }

  const handleFallback = () => {
    if (token) {
      store.dispatch('auth/setSession', { token, expire, user, name, storage: true })
    }
  }

  const sessionPromise = appToken
    ? api.auth.auth.createSession({ token: appToken })
        .then((data) => {
          cleanAppTokenUrl()
          return handleSuccess(data)
        })
    : api.userform.contactSettings.get(true)
        .then(handleSuccess)

  sessionPromise
    .catch(handleFallback)
    .finally(() => {
      store.commit('auth/setCheckedSession')
    })
}


const eventMonitor = new Vue()
const options = {
  eventEmitter: eventMonitor,
  idleTime: 3000
}

const tracker = new Tracker({
  projectKey: "AsPUUy0idqVZNj4Y9nwF",
  ingestPoint: "https://session.corp.caselocker.app/ingest",
  network: {
    capturePayload: true,
  },
  __DISABLE_SECURE_MODE: process.env.NODE_ENV !== "production"
})
tracker.use(trackerAssist())
import { mapGetters, mapMutations } from 'vuex'


Vue.mixin({
  data () {
    return {
      isProduction: (process.env.NODE_ENV === "production"),
      showAppUpdateDialog: false
    }
  },
  computed: {
    ...mapGetters('auth', [
      'getDomainInfo',
    ]),
    app_name () {
      return this.getDomainInfo.app_name || null
    }
  },
  methods: {
    getTracker() {
      return tracker
    },
    startTracker(userInfo) {
      var domain = /:\/\/([^\/]+)/.exec(window.location.href)[1]
      tracker.stop()
      tracker.start({
        userID: userInfo['name'],
        metadata: {
          admin: 'false',
          client: 'true',
          dev: !this.isProduction,
          org: this.isProduction ? domain : 'localhost',
          username: userInfo['username'],
          user_id: userInfo['id'],
        }
      })
    },
    isMobileApp () {
      return window.ReactNativeWebView && window.ReactNativeWebView.postMessage !== undefined
    },
    postMobileMessage (message) {
      if (this.isMobileApp())
        window.ReactNativeWebView.postMessage(message)
    },
    documentTitle (subTitle) {
      if (this.getDomainInfo.app_name)
        document.title = subTitle + " | " + this.getDomainInfo.app_name
      else
        document.title = subTitle
    },
    convertToLocal (utc) {
      var stillUtc = moment.utc(utc).toDate()
      var local = moment(stillUtc).local().format('YYYY-MM-DD HH:mm:ss')
      return local
    },
    convertToCalRef (utc) {
      var stillUtc = moment.utc(utc).toDate()
      var local = moment(stillUtc).calendar()
      return local
    },
    convertToPeriodicRef (utc) {
      var stillUtc = moment.utc(utc).toDate()
      var local = moment(stillUtc).fromNow()
      return local
    },
    getSignResponse (status) {
      switch (status.toLowerCase()) {
        case 'created':
          return 'Waiting for others...'
        case 'sent':
          return 'Signature Requested'
        case 'delivered':
          return 'Opened'
        case 'signed':
        case 'completed':
          return 'Signed'
        case 'declined':
          return 'Declined to Sign'
        case 'autoresponded':
          return 'Failed to Deliver'
        case 'faxpending':
          return 'Fax Pending'
      }
    },
    convertToLocalWithoutTime (utc) {
      var stillUtc = moment.utc(utc).toDate()
      var local = moment(stillUtc).local().format('YYYY-MM-DD')
      return local
    },
    getRootDomain () {
      var hostname = window.location.hostname
      var domainParts = hostname.split('.');
      if (domainParts.length > 2) {
        return domainParts.slice(-2).join('.');
      } else {
        return hostname;
      }    
    },
    isLegacyDomain () {
      return this.getRootDomain() == "litigationlocker.com"
    },
    isNewDomain () {
      return this.getRootDomain() == "caselocker.com"
    }
  }
})

Vue.use(VueScrollactive)
Vue.use(Vuetify)
Vue.use(IdleVue, options)
Vue.use(UUID)
Vue.use(VueSignaturePad)

if (process.env.NODE_ENV === "production") {
  Vue.config.silent = true
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})
